import React, { useState, useEffect } from 'react';
import { Form, Field } from 'react-final-form';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Button, TextField, Container, Paper, Typography, Box } from '@mui/material';
import { useAuthenticated } from 'react-admin';
import { Link } from 'react-router-dom';
import jwt_decode from 'jwt-decode';
import HowToRegIcon from '@mui/icons-material/HowToReg'; 

const DatePickerAdapter = ({ input, meta, ...rest }) => (
    <DatePicker
        className="datepicker"
        selected={input.value ? new Date(input.value) : null}
        onChange={(date) => input.onChange(date ? date.toISOString() : null)}
        {...rest}
    />
);

const required = (value) => (value ? undefined : 'Required');

const KioskInterface = () => {
    useAuthenticated();
    const [message, setMessage] = useState('');
    const [showMessage, setShowMessage] = useState(false);
    const location = localStorage.token ? jwt_decode(localStorage.token).location : '';

    const onSubmit = async (values) => {
        try {
            const response = await fetch(process.env.REACT_APP_VERIFY_URL, {
                method: 'POST',
                body: JSON.stringify(values),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });

            const data = await response.json();
            if (data.result === 'info') {
                window.location.href = `#/questions/create?ssn=${values.ssn}`;
            } else {
                setMessage(data.message);
                setShowMessage(true);

                // Hide message after 5 seconds
                setTimeout(() => {
                    setShowMessage(false);
                }, 10000);
            }
        } catch (err) {
            console.error('Error:', err);
            setMessage('An error occurred while verifying. Please try again.');
            setShowMessage(true);

            // Hide message after 5 seconds
            setTimeout(() => {
                setShowMessage(false);
            }, 5000);
        }
    };

    return (
        <Container maxWidth="sm" sx={{ textAlign: 'center', mt: 5 }}>
            <Paper elevation={6} sx={{ p: 4, borderRadius: 3, textAlign: 'center' }}>
                <Typography variant="h4" sx={{ mb: 2 }}>✔️ Donor Verification at {location}</Typography>
                <Box sx={{ 
                    border: '1px solid #ccc',  // ✅ Soft, mild border on all sides
                    borderRadius: 4,           // ✅ Smooth rounded corners
                    p: 2,                      // ✅ Padding for spacing inside the box
                    my: 2,                     // ✅ Margin for spacing outside the box
                    boxShadow: 1,              // ✅ Subtle shadow for a softer look
                    bgcolor: 'background.paper' // ✅ Matches theme background
                }}>
                    <Typography variant="h5" color="primary">New Donor? Click Register</Typography>
                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<HowToRegIcon />}
                        component={Link}
                        to="/Registration/Create"
                        sx={{ mt: 2, mb: 3, width: '100%', fontSize: 18 }}
                    >
                        Register
                    </Button>
                </Box>
                <Box sx={{ 
                    border: '1px solid #ccc',  // ✅ Soft, mild border on all sides
                    borderRadius: 4,           // ✅ Smooth rounded corners
                    p: 2,                      // ✅ Padding for spacing inside the box
                    my: 2,                     // ✅ Margin for spacing outside the box
                    boxShadow: 1,              // ✅ Subtle shadow for a softer look
                    bgcolor: 'background.paper' // ✅ Matches theme background
                }}>
                <Typography variant="h5" color="primary">Recurring Donor? Enter Details</Typography>
                <Form
                    onSubmit={onSubmit}
                    render={({ handleSubmit }) => (
                        <form onSubmit={handleSubmit}>
                            <Box sx={{ mb: 2 }}>
                                <Field name="ssn" validate={required}>
                                    {({ input, meta }) => (
                                        <TextField
                                            {...input}
                                            label="Social Security Number"
                                            fullWidth
                                            variant="outlined"
                                            error={meta.touched && meta.error}
                                            helperText={meta.touched && meta.error}
                                        />
                                    )}
                                </Field>
                            </Box>

                            <Box sx={{ mb: 2 }}>
                                <Field name="dob" validate={required}>
                                    {({ input }) => (
                                         <DatePickerAdapter
                                         input={input} // ✅ Ensure input is explicitly passed
                                         dateFormat="MM/dd/yyyy"
                                         placeholderText="Date of Birth"
                                         customInput={
                                             <TextField
                                                 fullWidth
                                                 variant="outlined"
                                                 label="Date of Birth"
                                                 sx={{ height: 56 }} // ✅ Match height to SSN input
                                             />
                                         }
                                     />
                                    )}
                                </Field>
                            </Box>
                            <Box sx={{ mb: 2 }}>
                                <Button type="submit" variant="contained" color="success" fullWidth sx={{ fontSize: 18 }}>
                                 Verify
                                </Button>

                            {/* ✅ Show message in a box and disappear after 5 seconds */}
                            {showMessage && (
                                <Box 
                                    sx={{ 
                                        mt: 2, 
                                        p: 2, 
                                        borderRadius: 2, 
                                        bgcolor: 'error.main', 
                                        color: 'white', 
                                        fontWeight: 'bold',
                                        fontSize: '16px'
                                    }}
                                >
                                    {message}
                                </Box>
                            )}
                            </Box>
                        </form>
                    )}
                />
                </Box>
            </Paper>
        </Container>
    );
};

export default KioskInterface;
